import React from 'react';
import { Check, X } from 'lucide-react';
export function FeatureComparisonSection() {
  const features = [{
    name: 'Speed',
    ours: 'Peels in seconds',
    others: 'Slow & tiring'
  }, {
    name: 'Safety',
    ours: 'Hands-free, safe operation',
    others: 'Risk of cuts'
  }, {
    name: 'Consistency',
    ours: 'Clean, consistent peels',
    others: 'Uneven & wasteful'
  }, {
    name: 'Convenience',
    ours: 'One-touch automatic use',
    others: 'Messy & difficult'
  }, {
    name: 'Portability',
    ours: 'Compact & lightweight',
    others: 'Bulky knives & tools'
  }, {
    name: 'Gift Value',
    ours: 'Perfect kitchen gift',
    others: 'Not a gift'
  }];
  return <div className="w-full max-w-[1400px] mt-16 px-4" data-id="element-256">
      {/* Section Heading */}
      <h2 className="text-3xl md:text-4xl font-bold text-black text-center mb-8" data-id="element-257">
        Feature Comparison
      </h2>

      {/* Comparison Table */}
      <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-258">
        {/* Header Row */}
        <div className="grid grid-cols-3 bg-black text-white" data-id="element-259">
          <div className="p-6 font-bold text-lg" data-id="element-260">Features</div>
          <div className="p-6 font-bold text-lg text-center" data-id="element-261">Ours</div>
          <div className="p-6 font-bold text-lg text-center" data-id="element-262">Others</div>
        </div>

        {/* Feature Rows */}
        {features.map((feature, index) => <div key={index} className={`grid grid-cols-3 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`} data-id="element-263">
            {/* Feature Name */}
            <div className="p-6 font-semibold text-black flex items-center" data-id="element-264">
              {feature.name}
            </div>

            {/* Ours Column */}
            <div className="p-6 flex flex-col items-center justify-center text-center" data-id="element-265">
              <Check className="w-8 h-8 text-green-500 mb-2" data-id="element-266" />
              <span className="text-sm text-black" data-id="element-267">{feature.ours}</span>
            </div>

            {/* Others Column */}
            <div className="p-6 flex flex-col items-center justify-center text-center" data-id="element-268">
              <X className="w-8 h-8 text-red-500 mb-2" data-id="element-269" />
              <span className="text-sm text-black" data-id="element-270">{feature.others}</span>
            </div>
          </div>)}
      </div>
    </div>;
}